//---------------------------------------------------
//  Nom du fichier : Rencontre.js 
//
//  Description: Component qui gère la logique de rencontre
//               Contient la logique de swiper à gauche et à droite
//               Contient la logique de drag le div
//               Contient un component pour chercher parmis le nom d'usager des profils
//               Permet de basculer sur la page d'un profil
//
//  Auteur: Alek Del Balso
//---------------------------------------------------

import { path_dict, sections, translate_grade } from './grades';
import React, { useState , useEffect, useRef} from 'react';
import {callAPI} from './callAPI.js'
import './Rencontre.css'
import './btn.css'
import { useNavigate,useParams } from 'react-router-dom';
import { LinkedListe, Node } from './LinkedList.js';
import { useTranslation } from "react-i18next";
import Recherche from './Recherche.js';

const ProfileCard = ({info, gradeType, swipe, isFecthing}) => {
    const { t } = useTranslation();

    const currentInfo = useRef(info)
    const [gradeColor, setGradeColor] = useState("--secondaryDark")
    const navigate = useNavigate();

    const cardRef = useRef()

    useEffect(() => {
        currentInfo.current = info
        setGradeColor("--secondaryDark")
        if(info.grade === null)return
        sections.forEach((section, index) => {
            if(section.includes(info.grade)){
                setGradeColor("--grade" + path_dict[index])
            }
        });
    },[info])

    useEffect(() => {
        const card = cardRef.current;
        if (!card || isFecthing) return;
    
        let isDragging = false;
        let offsetX = 0;
        let isSwipe = false;
    
        const getClientX = (e) => {
            return e.touches ? e.touches[0].clientX : e.clientX;
        };
    
        const handleStart = (e) => {
            e.preventDefault(); // empêche le comportement par défaut seulement si on commence à dragger
            isDragging = true;
            isSwipe = false; // Initialement, on n'est pas en train de swiper
            offsetX = getClientX(e) - card.offsetLeft;
    
            card.style.transition = "none";
        };
    
        const handleMove = (e) => {
            if (isDragging) {
                const clientX = getClientX(e);

                card.style.left = `${clientX - offsetX}px`;
                card.style.rotate = `${(clientX - offsetX) / 30}deg`;
                if(Math.abs(clientX - offsetX ) > 150){
                    card.style.boxShadow = `0px 0px ${Math.abs((clientX - offsetX) / 6)}px ${
                        (clientX - offsetX) > 0 ? "green" : "red"
                    }`;
                }
                else{
                    
                    card.style.boxShadow = "none";
                }
                if (Math.abs(clientX - offsetX) > 10) {
                    isSwipe = true; // Si le déplacement est important, on considère que c'est un swipe
                }
            }
        };
    
        const handleEnd = (e) => {
            if (isDragging) {
                const clientX = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
    
                card.style.transition = "all 0.3s";
                card.style.left = '0px';
                card.style.rotate = `0deg`;
                card.style.boxShadow = "none";
    
                if (clientX - offsetX > 150) {
                    swipe('right');
                } else if (clientX - offsetX < -150) {
                    swipe('left');
                }


    
                // Si ce n'est pas un swipe, autorise le clic sur le lien
                if (!isSwipe) {
                    // Si ce n'était pas un swipe, permettre le clic sur le lien
                    navigate(`/profil/${currentInfo.current.id}/rencontre`)
                }
            }
            isDragging = false;
        };
    
        // Mouse events
        card.addEventListener("mousedown", handleStart);
        document.addEventListener("mousemove", handleMove);
        document.addEventListener("mouseup", handleEnd);
    
        // Touch events
        card.addEventListener("touchstart", handleStart, { passive: false });
        document.addEventListener("touchmove", handleMove, { passive: false });
        document.addEventListener("touchend", handleEnd);
    
        return () => {
            // Mouse events
            card.removeEventListener("mousedown", handleStart);
            document.removeEventListener("mousemove", handleMove);
            document.removeEventListener("mouseup", handleEnd);
    
            // Touch events
            card.removeEventListener("touchstart", handleStart);
            document.removeEventListener("touchmove", handleMove);
            document.removeEventListener("touchend", handleEnd);
        };
    }, [isFecthing]);

    if(info.id == -1){
        return(<p className='no_more_profiles'>{info.message}</p>)
    }
    
    const pImage = {
        backgroundImage: info.file_path && info.file_path !== null ? `url('https://rockstoclimb.com/uploads/profiles/${info.file_path}')` : "url('/Images/defImage.png')"
    }

    return(
        <>
            <div className='card' ref={cardRef}>
                <div className='photo-user'>
                    <div className='rencontre_photo' style={pImage}></div>
                    <div className='rencontre_username'>{info.username}</div>
                    <div className='rencontre_grade' style={{backgroundColor: `var(${gradeColor})`}}>{translate_grade(gradeType, info.grade) ?? "?"}</div>
                </div>
                <div className='info-user'>
                    <div className='rencontre_prenom'>{info.first_name} {info.last_name}</div>
                    <div className='rencontre_bio'>{info.bio ?? "Aucune bio"}</div>
                    <div className='utils-user'>
                        <div className='nbPost'>{info.nbPost} {t('post')}</div>
                        <div className='nbFollower'>{info.nbFollower} {t('followers')}</div>
                        <div className='nbFollowing'>{info.nbFollowing} {t('following')}</div>
                    </div>
                </div>
            </div>

        </>
    )
}

const Rencontre = ({gradeType, ws}) => {
    let { id } = useParams(); 
    const profilesList = useRef(new LinkedListe())
    const [isLoading, setIsLoading] = useState(false)
    const [noMoreProfiles, setNoMoreProfiles] = useState(false)
    const [isFecthing, setIsFetching] = useState(false)
    const currentProfileRef = useRef(null);

    const { t } = useTranslation();

    useEffect(() => {
        currentProfileRef.current = profilesList.current.get(0);
    }, [profilesList.current.get(0)]);

    const navigate = useNavigate();

    const fetch_profiles = (id) => {
        if(isLoading) return


        setIsLoading(true)
        let form = new FormData()
        form.append("type","get_random_profiles")
        if(id)
            form.append("id",id)
        callAPI("read", form)
        .then((data) => {
            profilesList.current.delete()
            if(data.result.length == 10){
                data.result.forEach(profile => profilesList.current.insertion_fin(new Node(profile)));
            }
            else{
                data.result.forEach(profile => profilesList.current.insertion_fin(new Node(profile)));
                profilesList.current.insertion_fin(new Node({ id: -1, message: "Aucun autre profil" }))
                setNoMoreProfiles(true)
            }
            setIsLoading(false)
        })
        .catch((error) => {
            console.error("API call failed:", error);
        });

    }

    const next_profile = (direction) => {
        const currentProfile = currentProfileRef.current;
        if (!currentProfile || currentProfile.id === -1) return;

        if(isFecthing)return

        setIsFetching(true)


        let form = new FormData()
        form.append("type","swipe")
        form.append("other_user_id", currentProfile.id);
        form.append("value",direction)
        callAPI("write", form)
        .then((data) => {

            if(data.status == "MATCH"){
                const form = new FormData()
                form.append('type', 'create_match')
                form.append("receiver_id", currentProfile.id);
                callAPI("write", form)
                .then((data) => {
                    const now = new Date();
                    const utcTimestamp = now.toISOString().slice(0, 19).replace('T', ' ');
                    if (ws && ws.readyState === WebSocket.OPEN) {
                        ws.send(JSON.stringify({ 
                            type: "message", 
                            my:false, 
                            to:currentProfile.id,
                            fromAdmin:1, 
                            id:data.status, 
                            receiver:currentProfile.id, 
                            sender:localStorage.getItem("user_id"),
                            created_at:utcTimestamp, 
                            message:t('match_info'), 
                            user_id:localStorage.getItem("user_id")
                        }));
                    }
                })
                .catch((error) => {
                    console.error("API call failed:", error);
                });
                alert(t('match_info'))
            }
            profilesList.current.supression_debut()
            if(profilesList.current.is_empty() && !noMoreProfiles){
                fetch_profiles(); 
            }
        })
        .catch((error) => {
            console.error("API call failed:", error);
        });
        setTimeout(() => {
            setIsFetching(false)
        },200)
    }

    useEffect(() => {
        if(localStorage.getItem("user_id") == -1)
            navigate("/")
        fetch_profiles(id); 
    }, []);  

    return (
        <div className='rencontre_container'>
            <Recherche/>
            <div className='middle_container'>
                <div className='profile'>
                     { !profilesList.current.is_empty() &&
                     <ProfileCard info={profilesList.current.get(0)} 
                                  gradeType={gradeType} 
                                  swipe={next_profile} 
                                  isFecthing={isFecthing}
                                  key={profilesList.current.get(0).id} />} 
                 </div>
                 <div id="control">
                    <span className="rencontre_arrow material-symbols-outlined" onClick={() => {next_profile('left')}}>arrow_back</span>
                    <span className="rencontre_arrow material-symbols-outlined" onClick={() => {next_profile('right')}}>arrow_forward</span>
                 </div>
            </div>
            <div style={{position:'absolute', right:'0'}}>   
                <span id="quit" className="material-symbols-outlined" onClick={() => { navigate("/") }} style={{ cursor: 'pointer' }}>close</span>
            </div>
        </div>
    );
};

export default Rencontre;